const HelperFunctions = {
    handleDriver(transfer, setTransfer) {
        if (transfer.depart === "GLA") {
            setTransfer(prevState => ({
                ...prevState,
                driverName: "Alex Brown",
                driverNumber: 7777777771
            }));
        } else if (transfer.depart === "EDI") {
            setTransfer(prevState => ({
                ...prevState,
                driverName: "David Cox",
                driverNumber: 7777777772
            }));
        } else if (transfer.depart === "MAN") {
            setTransfer(prevState => ({
                ...prevState,
                driverName: "John Gilmour",
                driverNumber: 7777777773
            }));
        } else {
            setTransfer(prevState => ({
                ...prevState,
                driverName: "No Details",
                driverNumber: 0
            }));
        }
    },

    validateFlight(transfer, setTransfer, flightNumberRegEx){
        console.log('Updating state to PENDING');
        if(!transfer.flightId) {
            transfer.flightId = "PENDING"
          return true
        } else if(transfer.flightId.match(flightNumberRegEx)){
            return true;
        } else {
                alert("Please enter a valid flight number. Flight Numbers should follow the format:\n" +
                    "• AA123  (2-letter airline code)\n" +
                    "• U21234  (airline code with a digit, e.g. easyJet U2, Wizz Air W9)\n" +
                    "• AAA123  (3-letter airline code)\n" +
                    "• followed by up to 4 digits");
                return false;
            }
    },

    // Sanity-check a transfer's date against the student's stays: an arrival
    // flight (IN) should fall on a stay's arrival date, a departure flight (OUT)
    // on a stay's departure date. A mismatch is the usual reason a student goes
    // missing from transfer lists (the transfer lands on the wrong day). Returns
    // { onBoundary, direction, target, expected } — onBoundary is true (nothing
    // to flag) for non IN/OUT directions or when there are no stays to check.
    // `stays` is the array from GET /api/student/{id}/stays.
    checkTransferDateAgainstStays(transfer, stays) {
        const toYmd = (d) => {
            if (!d) return null;
            if (d instanceof Date) {
                const y = d.getFullYear();
                const m = String(d.getMonth() + 1).padStart(2, "0");
                const day = String(d.getDate()).padStart(2, "0");
                return `${y}-${m}-${day}`;
            }
            return String(d).slice(0, 10);
        };

        const dir = String(transfer?.direction || "").toUpperCase();
        if (dir !== "IN" && dir !== "OUT") return { onBoundary: true };
        if (!Array.isArray(stays) || stays.length === 0) return { onBoundary: true };

        const field = dir === "IN" ? "arrivalDate" : "departureDate";
        const target = toYmd(transfer?.transferDate);
        const expected = stays.map((s) => toYmd(s?.[field])).filter(Boolean);

        return {
            onBoundary: expected.includes(target),
            direction: dir,
            target,
            expected,
        };
    },

};

export default HelperFunctions;